import { render, staticRenderFns } from "./DepartmentsRegistryNewForm.vue?vue&type=template&id=679517f5"
import script from "./DepartmentsRegistryNewForm.vue?vue&type=script&lang=js"
export * from "./DepartmentsRegistryNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports